import _ from 'lodash';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import { FileGallery } from '~';
import { STATUSES, GOAL_LEAD_GENERATION, CREATIVE_STATUSES, CAMPAIGN_TYPES } from '@/util/constants';
import { mapState } from 'vuex';
import FillStatus from '@/components/rabbit/fill-status/FillStatus.vue';
import CreativePreviewWrapper from '@/components/rabbit/creative-preview-wrapper/CreativePreviewWrapper.vue';
import Creative from './creative/Creative.vue';

export default {
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      swiperOption: {
        autoplay: false,
        watchOverflow: true,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
      },
    };
  },
  components: {
    swiper,
    'swiper-slide': swiperSlide,
    creative: Creative,
    'fill-status': FillStatus,
    'file-gallery': FileGallery,
    'creative-preview-wrapper': CreativePreviewWrapper,
  },
  methods: {
    showCreativePreview(status) {
      return status === CREATIVE_STATUSES.READY
        || status === CREATIVE_STATUSES.APPROVED;
    },
    openCreative(creativeId) {
      this.$router.push({
        name: 'creative',
        params: { id: creativeId },
      });
    },
    isExternalCreative(creative) {
      return _.get(creative, 'type', null) === CAMPAIGN_TYPES.EXTERNAL;
    },
    getCreativeExternalPreviews(creative) {
      return _.get(creative, 'external_previews', []).map(p => ({
        ...p,
        href: p.path,
        type: p.content_type,
      }));
    },
  },
  computed: {
    ...mapState('campaign', { campaign: 'current' }),
    creatives() {
      return _.get(this.campaign, 'creatives', []);
    },
    activeCreative() {
      return this.creatives.find(creative => creative.active);
    },
    inactiveCreatives() {
      return this.creatives.filter(creative => !creative.active);
    },
    showSplit() {
      return this.inactiveCreatives.length && this.campaign.baseStatus.code === STATUSES.ONL;
    },
    facebookPage() {
      return this.campaign.fbpage;
    },
    showPreview() {
      return this.campaignInReady || this.campaignInFinished || this.campaignInOnline;
    },
    campaignInReady() {
      return this.campaign.steps.currentStep.code === STATUSES.CAP;
    },
    campaignInFinished() {
      return this.campaign.steps.currentStep.code === STATUSES.FIN;
    },
    campaignInOnline() {
      return this.campaign.steps.currentStep.code === STATUSES.ONL;
    },
    readyForCAP() {
      return _.get(this.campaign, 'ready_for_cap.creatives', false);
    },
    showWarningForCreatives() {
      let show = false;
      if (this.creatives.length > 0) {
        this.creatives.forEach(item => {
          if (!this.showCreativePreview(item.status)) {
            show = true;
          }
        });
      }
      return show;
    },
    creativeColumnSize() {
      if (_.get(this.campaign, 'campaign_rule.goal_type', null) === GOAL_LEAD_GENERATION) {
        return 'col-md-8';
      } else if (_.get(this.campaign, 'type', null) === CAMPAIGN_TYPES.EXTERNAL) {
        return 'col-md-12';
      }
      return 'col-md-6';
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/rabbit/campaign-creatives/CampaignCreatives.js